module.exports = __webpack_public_path__ + "img/barbell.3303ce9.svg";